<template>
  <div :class="[$style['pt-page-factor-filter'],displayVertical ? $style['isVertial'] :'',isCustomer ? $style['isCustomer'] :'']" class="page-factor-filter-top">
    <div :class="$style['pt-factor-filter-labels']">
      <div v-for="(item,index) in labels" :key="index" :class="$style['pt-factor-filter-labels__item']">
        <label v-if="item.label" :style="labelWidth ? {width:labelWidth,display:'inline-block',textAlign:'right'} : {}">
          {{item.label}}：
        </label>
        <template v-if="item.slotName">
          <slot :name="item.slotName" />
        </template>
        <wt-selector ref="wtSelector" v-else-if="item.type=='select'" :style="{width: item.width + 'px'}" :multiple="item.multiple" :options="item.options" :props="item.props" :disabled="item.disabled" :filterable="item.filterable" :clearable="item.clearable" :value="crrentValue[item.value]" :valueFileds="item.value"
                     :showPlacehodlerAlways="item.showPlacehodlerAlways" :placeholder="item.placeholder" @change="changeSelect"></wt-selector>
        <el-date-picker
          v-else-if="item.type=='date'"
          v-model="crrentValue[item.value]" 
          :clearable="item.clearable" 
          :placeholder="item.placeholder || '选择日期'"
          type="date">
        </el-date-picker>
          
        <wt-input v-else-if="item.type=='input'" v-model="crrentValue[item.value]" :clearable="item.clearable" :placeholder="item.placeholder"></wt-input>
        <pt-time-slot v-else-if="item.type=='time-slot'" :startLabel="item.startName" :endLabel="item.endName" @change="timeChange" :startTime="(crrentValue[item.value]&&crrentValue[item.value][item.startName])||crrentValue[item.startName]"
                      :endTime="(crrentValue[item.value]&&crrentValue[item.value][item.endName])||crrentValue[item.endName]" :index="item.value||index"></pt-time-slot>
        <pt-price-slot :minLabel="item.minName" :maxLabel="item.maxName" v-else-if="item.type=='price-slot'||item.type=='number-slot'" :type="item.type=='number-slot'?'number':'price'" :minPrice="(crrentValue[item.value]&&crrentValue[item.value][item.minName])||crrentValue[item.minName]"
                       :maxPrice="(crrentValue[item.value]&&crrentValue[item.value][item.maxName])||crrentValue[item.maxName]" :minPlaceholder="item.minPlaceholder" :maxPlaceholder="item.maxPlaceholder" @change="priceChange" :clearable="item.clearable"></pt-price-slot>
      </div>
      <div :class="[$style['pt-page-menu-filter-button'],displayVertical ? $style['addPadding'] :'']">
        <slot />
      </div>
    </div>

  </div>
</template>
<script>
import { isEmptyObject, cashCount } from '@/utils/formUtils'
import wtSelector from 'cps/base/wt-selector'
export default {
  name: 'pt-page-factor-filter',
  components: {
    wtSelector
  },
  props: {
    isCustomer: {
      type: Boolean
    },
    labels: {
      type: Array,
      default: function () {
        return []
      }
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    displayVertical: {
      type: Boolean,
      default: false
    },
    isQueryRouter: {
      type: Boolean,
      default: false
    },
    labelWidth:{
      type: String,
      default: ''
    }
  },
  data () {
    return {
      crrentValue: this.value
    }
  },
  watch: {
    value:{
      handler:function(val){
        if (JSON.stringify(val) !== JSON.stringify(this.crrentValue)) {
          this.crrentValue = JSON.parse(JSON.stringify(val))
        }
      },
      deep:true
    },
    crrentValue: {
      handler: function (val) {
        for (var i in val) {
          this.labels.forEach(item => {
            if (!val[i] && i === item.value && item.type === 'select' && item.multiple) {
              val[i] = []
            }
          })
        }
        this.$emit('input', JSON.parse(JSON.stringify(val)))
      },
      deep: true
    }
  },
  methods: {
    changeSelect (val, filed) {
      console.log(val, filed)
      if (filed) {
        this.$set(this.crrentValue, filed, val)
      }
      // this.$emit('input', JSON.parse(JSON.stringify(this.crrentValue)))
    },
    // 将参数传到router中
    getAddRouter (params) {
      if (this.isQueryRouter) {
        let query = this.$route.query
        for (var key in params) {
          if (typeof (params[key]) === 'object') {
            if (!isEmptyObject(params[key])) {
              for (var key1 in params[key]) {
                if (!params[key][key1]) {
                  this.$delete(params[key], key1)
                }
              }
              params = { ...params, ...params[key] }
            }
            this.$delete(params, key)
          }
          if (!params[key]) {
            this.$delete(params, key)
          }
        }
        this.$router.push({ name: this.$route.name, query: { page: query.page, ...params } })
      }
    },
    timeChange (val) {
      let newobj = {}
      this.labels.forEach(item => {
        if (item.type === 'time-slot' && item.value === val.index) {
          newobj[item.value] = val
        }
      })
      if (val.index) {
        Object.assign(this.crrentValue, newobj)
      } else {
        Object.assign(this.crrentValue, val)
      }
      this.$emit('input', this.crrentValue)
    },
    priceChange (val) {
      let newobj = {}
      this.labels.forEach(item => {
        if ((item.type === 'price-slot' || item.type === 'number-slot') && item.value) {
          newobj[item.value] = val
        }
      })
      Object.assign(this.crrentValue, newobj)
      this.$emit('input', this.crrentValue)
    },
    queryRouterData () {
      if (this.isQueryRouter && JSON.stringify(this.$route.query) !== '{}') {
        let query = this.$route.query
        this.crrentValue = { ...query }
        this.labels.forEach(item => {
          if (item.type === 'time-slot') {
            this.crrentValue[item.value] = this.crrentValue[item.value] || {}
            this.crrentValue[item.value][item.startName] = (query[item.startName] && query[item.startName]) || null
            this.crrentValue[item.value][item.endName] = (query[item.endName] && query[item.endName]) || null
            if (this.crrentValue[item.startName]) {
              this.$delete(this.crrentValue, item.startName)
            }
            if (this.crrentValue[item.endName]) {
              this.$delete(this.crrentValue, item.endName)
            }
          }
          if (item.type === 'price-slot') {
            this.crrentValue[item.value] = this.crrentValue[item.value] || {}
            this.crrentValue[item.value][item.maxName] = query[item.maxName] && cashCount(query[item.maxName], true)
            this.crrentValue[item.value][item.minName] = query[item.minName] && cashCount(query[item.minName], true)
            if (this.crrentValue[item.maxName]) {
              this.$delete(this.crrentValue, item.maxName)
            }
            if (this.crrentValue[item.minName]) {
              this.$delete(this.crrentValue, item.minName)
            }
          }
          if (item.type === 'select' && item.multiple) {
            this.crrentValue[item.value] = this.crrentValue[item.value] || []
            for (var key in this.crrentValue) {
              if (!isNaN(Number(key))) {
                this.crrentValue[item.value].push(this.crrentValue[key])
                this.$delete(this.crrentValue, key)
              }
            }
          }
        })
        if (!isEmptyObject(query)) {
          this.$delete(this.crrentValue, 'page')
          this.$emit('input', JSON.parse(JSON.stringify(this.crrentValue)))
          this.$emit('Filter', true)
        }
      }
    }
  },

  created () {
    this.queryRouterData()
  }
}
</script>
<style module lang="less">
.pt-page-factor-filter{
  display: flex;
  margin: 15px 0;
  :global
  .el-button{
    padding: 0.1rem 0.2rem;
    margin-bottom: 20px;
    &:last-child{
      margin-right: 0;
    }
    &.el-button--text{
        padding: 12px 0;
    }
    &+.el-button{
      margin-left: 30px;
    }
  }
}

.pt-factor-filter-labels{
    display: flex;
    flex-wrap: wrap;
    // >div.pt-factor-filter-labels__item{
    //     margin-right: 18px;
    // }
}
.pt-factor-filter-labels__item{
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    margin-right: 18px;
    :global
    .wt-input{
        display: flex;
        width: 180PX;

    }
    label{
        margin-right: 0px;
        text-align: right
    }
    :global
    .el-select{
      width: 180PX;
    }
    :global
    .wt-selector{
        width: 180PX;
        display: flex;
        .el-select__tags{
            max-width: 180Px;
            .el-tag--info{
                white-space: inherit;
                display: inline-table
            }
        }

    }
    :global
    .el-date-editor{
        width: 180PX;
    }
}

// .isVertial{
//     display: block;
// }
.addPadding{
    // padding:20px 0;
    width: 100%
}
.isCustomer{
  margin: 0;
  .pt-factor-filter-labels__item{
    margin-bottom: 0;
    margin-right: 0px;
  }
  :global{
    .el-input__inner{
      border: 0;
      color: #409eff;
      height: 20px;
    }
    .el-input__icon{
      line-height: 20px;
    }
    .el-input__inner::placeholder{
      color: #409eff;
    }
    .el-select .el-input .el-select__caret{
      color: #409eff;
    }
    .wt-selector{
      width: 150PX;
    }
  }
}
</style>
